export const content = {
    SK: {
        nav: {
            about: "O NÁS",
            services: "SLUŽBY",
            vehicles: "GARÁŽ",
            contact: "KONTAKT",
        },
        hero: {
            title: "Medzinárodná a vnútroštátna preprava",
            subtitle: "Spoľahlivosť a individuálny prístup od roku 2011.",
        },
        about: {
            title: "Kto sme?",
            text: "Sme slovenská dopravná spoločnosť a zaoberáme sa vnútroštátnou nákladnou cestnou dopravou a medzinárodnou cestnou nákladnou dopravou. Na trhu pôsobíme od decembra 2011. Naše sídlo sa nachádza v Nižnom Čaji. Hlavným zámerom ANTHONY TRANSPORT s.r.o je preprava komodít, krmovín a paletového tovaru. Sme držiteľom certifikátu GMP+B4.",
        },
        services: {
            title: "Ponúkame prepravu do viac ako 20 krajín",
            text: "Medzi najčastejšie krajiny patrí Slovensko, Maďarsko, Česká Republika, Rakúsko, Taliansko, Poľsko a Slovinsko. Ročne prepravíme viac ako 400 zakázok.",
            subText: "Doručujeme aj do ostatných európskych krajín, neváhajte nás kontaktovať.",
            countries: [
                "Slovensko", "Maďarsko", "Česká Republika", "Rakúsko", "Taliansko", "Poľsko"
            ]
        },
        vehicles: {
            title: "Vozový park",
            text1: "Náš vozový park tvorí 5 ťahačov značky Volvo FH-500, ktoré je možné kombinovať v súprave:",
            list: [
                "veľkokapacitnými návesmi walking floor (90m3)",
                "sklápacím návesom (55m3)"
            ],
            text2: "Všetky naše vozidlá majú emisnú normu EURO 6. O naše vozidlá dbáme a pravidelne podliehajú všetkým náležitým prehliadkam a servisu.",
        },
        contact: {
            title: "Kontakt",
            person: "Kontaktná osoba",
            office: "Sídlo",
            formTitle: "Nezáväzný dopyt",
            labels: {
                name: "Meno a priezvisko",
                email: "Email",
                phone: "Telefónne číslo",
                pickupCity: "Mesto odvozu",
                pickupAddr: "Adresa odvozu",
                deliveryCity: "Mesto dovozu",
                deliveryAddr: "Adresa dovozu",
                message: "Správa",
                gdpr: "Súhlasím so spracovaním osobných údajov",
                send: "Odoslať"
            },
            errors: {
                email: "Nesprávny formát emailu",
            }
        },
        footer: {
            copyright: "© Anthony Transport",
            links: ["Prepravné podmienky", "Zmluvné podmienky", "Prepravný certifikát"]
        }
    },
    EN: {
        nav: {
            about: "ABOUT",
            services: "SERVICES",
            vehicles: "VEHICLES",
            contact: "CONTACT",
        },
        hero: {
            title: "Domestic and International Transport",
            subtitle: "Reliability and individual approach since 2011.",
        },
        about: {
            title: "About Us",
            text: "We are a Slovak transportation company that focuses on domestic and international road freight transport. We have been operating on the market since December 2011. Our headquarters are located in Nižný Čaj. The main focus of ANTHONY TRANSPORT s.r.o. is transportation of commodities, fodder and palletized goods. We hold the GMP+B4 certificate.",
        },
        services: {
            title: "We offer shipping to more than 20 countries",
            text: "The most common countries include Slovakia, Hungary, Czech Republic, Austria, Italy, Poland and Slovenia. We transport more than 400 orders annually.",
            subText: "We also deliver to other European countries, so don't worry to contact our team.",
            countries: [
                "Slovakia", "Hungary", "Czech Republic", "Austria", "Italy", "Poland"
            ]
        },
        vehicles: {
            title: "Our Car Fleet",
            text1: "Our car fleet consists of 5 Volvo FH-500 truck units, which can be combined with:",
            list: [
                "large capacity semi-trailers walking floor (90m3)",
                "tipper trailers (55m3)"
            ],
            text2: "All our vehicles have the EURO 6 emission standard. We thoroughly care for our vehicles and they regularly undergo all proper inspections and service.",
        },
        contact: {
            title: "Contact",
            person: "Contact person",
            office: "Office",
            formTitle: "Contact our team",
            labels: {
                name: "Name and surname",
                email: "Email",
                phone: "Mobile number",
                pickupCity: "City of pickup",
                pickupAddr: "Address of pickup",
                deliveryCity: "Import city",
                deliveryAddr: "Address of import",
                message: "Message",
                gdpr: "I agree to the processing of personal data",
                send: "Send"
            },
            errors: {
                email: "Wrong email format",
            }
        },
        footer: {
            copyright: "© Anthony Transport",
            links: ["Transport conditions", "Terms and conditions", "Transport certificate"]
        }
    }
};